import React from "react";
import { Navigate } from "react-router-dom";
import { isUserLoggin } from "../_helpers/auth.helper";

/**
 * Soft UX gate only (user cookie + tab sessionStorage).
 * Authoritative auth is the httpOnly auth-token JWT on the BFF; treat API 401 as logout.
 */
export const PrivateRoute = ({ element }) => {
  if (isUserLoggin()) {
    return element;
  } else {
    return <Navigate to="/" replace />;
  }
};
